module.exports = __webpack_public_path__ + "static/media/reclassification-tree.14908f7e.svg";